/**
 * Backend API Configuration
 */
import { getApiBaseUrl } from '../utils/apiBaseUrl';

const BACKEND_CONFIG = {
  // Backend API URL - defaults to localhost for development
  API_URL: getApiBaseUrl(),
  
  // Timeout settings (in milliseconds)
  TIMEOUT: 60000, // 60 seconds
  
  // Retry settings
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
};

export default BACKEND_CONFIG;
